import { render, staticRenderFns } from "./TabelaResultadosStatusUsuario.vue?vue&type=template&id=f0157d0c&scoped=true&"
import script from "./TabelaResultadosStatusUsuario.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosStatusUsuario.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosStatusUsuario.vue?vue&type=style&index=0&id=f0157d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0157d0c",
  null
  
)

export default component.exports